var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "homePage" }, [
    _c("div", { staticClass: "mainbox" }, [
      _c(
        "div",
        { staticClass: "course_search_bar" },
        [
          _c("Search", {
            attrs: {
              type: 1,
              majorName: _vm.query.majorName,
              courseName: _vm.query.courseName,
            },
            on: { toSsearch: _vm.toSsearch },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "homeTabNav" }, [
        _c(
          "div",
          { staticClass: "homeNavBx" },
          _vm._l(_vm.homeNavList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "homeNavt",
                on: {
                  click: function ($event) {
                    return _vm.toSecond(item.url)
                  },
                },
              },
              [
                _c("div", { staticClass: "homeNavb" }, [
                  _c("div", { staticClass: "imgbg" }, [
                    _c("img", { attrs: { src: item.img, alt: "" } }),
                  ]),
                  _vm._v(" "),
                  _c("h5", [_vm._v(_vm._s(item.name))]),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "perbox" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btnlist" },
          _vm._l(_vm.perp, function (item, index) {
            return _c(
              "p",
              {
                key: index,
                class: { newisactivityp: _vm.perpflag == index },
                on: {
                  click: function ($event) {
                    return _vm.getperp(index)
                  },
                },
              },
              [_vm._v("\n          " + _vm._s(item.name) + "\n        ")]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.perpflag == 0,
                expression: "perpflag == 0",
              },
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "contbox",
          },
          [
            _vm._l(_vm.servelist, function (item, index) {
              return _c("CourseResource", {
                key: index,
                attrs: { type: 1, item: item },
              })
            }),
            _vm._v(" "),
            _vm.servelist.length == 0
              ? _c(
                  "div",
                  {
                    staticClass: "noData",
                    staticStyle: {
                      "wmargin-top": "50px",
                      "text-align": "center",
                      width: "100%",
                    },
                  },
                  [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
                )
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.perpflag == 1 || _vm.perpflag == 2,
                expression: "perpflag == 1 || perpflag == 2",
              },
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading1,
                expression: "loading1",
              },
            ],
            staticClass: "contbox",
          },
          [
            _vm._l(_vm.servelist_2, function (item, index) {
              return _c("CourseItem", {
                key: index,
                attrs: { type: 8, item: item },
              })
            }),
            _vm._v(" "),
            _vm.servelist_2.length == 0
              ? _c(
                  "div",
                  {
                    staticClass: "noData",
                    staticStyle: {
                      "wmargin-top": "50px",
                      "text-align": "center",
                      width: "100%",
                    },
                  },
                  [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
                )
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.perpflag == 3,
                expression: "perpflag == 3",
              },
            ],
            staticClass: "contbox",
          },
          [
            _vm._l(_vm.tjList, function (item, index) {
              return _c("CourseItemT", {
                key: index,
                attrs: { type: 10, item: item },
              })
            }),
            _vm._v(" "),
            _vm.tjList.length == 0
              ? _c(
                  "div",
                  {
                    staticClass: "noData",
                    staticStyle: {
                      "wmargin-top": "50px",
                      "text-align": "center",
                      width: "100%",
                    },
                  },
                  [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
                )
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "lookmore",
            on: {
              click: function ($event) {
                return _vm.getmore("allModule")
              },
            },
          },
          [_vm._v("查看更多")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "virtualbox" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "contbox" },
          [
            _vm.xunilist.length > 0
              ? [
                  _vm._l(_vm.xunilist, function (item, index) {
                    return _c("courseTwo", {
                      key: index,
                      attrs: { type: 1, item: item },
                    })
                  }),
                  _vm._v(" "),
                  _vm.xunitotal > 4
                    ? _c(
                        "div",
                        {
                          staticClass: "leftarrowbox",
                          on: {
                            click: function ($event) {
                              return _vm.getleft(-1)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "noneimg",
                            attrs: {
                              src: require("../../../assets/img/arrow-more.png"),
                              alt: "",
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "posiimg",
                            attrs: {
                              src: require("../../../assets/img/arrow-more2.png"),
                              alt: "",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.xunitotal > 4
                    ? _c(
                        "div",
                        {
                          staticClass: "rightarrowbox",
                          on: {
                            click: function ($event) {
                              return _vm.getleft(1)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "noneimg",
                            attrs: {
                              src: require("../../../assets/img/arrow-more.png"),
                              alt: "",
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "posiimg",
                            attrs: {
                              src: require("../../../assets/img/arrow-more2.png"),
                              alt: "",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]
              : _c("div", { staticClass: "noData virtual_no_data" }, [
                  _c("img", { attrs: { src: _vm.$store.getters.noData } }),
                ]),
          ],
          2
        ),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "lookmore",
            on: {
              click: function ($event) {
                return _vm.getmore("virtual")
              },
            },
          },
          [_vm._v("查看更多")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "teabox" }, [
        _vm._m(2),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "contbox" },
          _vm._l(_vm.tealist, function (item, index) {
            return _c("CourseItemT", {
              key: index,
              attrs: { type: 5, item: item },
            })
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "lookmore",
            on: {
              click: function ($event) {
                return _vm.getmore("teacherPower")
              },
            },
          },
          [_vm._v("查看更多")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "teachingbox" }, [
        _vm._m(3),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "contbox", attrs: { name: "el-fade-in-linear" } },
          [
            _vm.jiaocailist.length > 0
              ? [
                  _vm._l(_vm.jiaocailist, function (item, index) {
                    return _c("CourseItemT", {
                      key: index,
                      attrs: { type: 9, item: item },
                    })
                  }),
                  _vm._v(" "),
                  _vm.jiaocaitotal > 4
                    ? _c(
                        "div",
                        {
                          staticClass: "leftarrowbox",
                          on: {
                            click: function ($event) {
                              return _vm.getjiaocaileft(-1)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "noneimg",
                            attrs: {
                              src: require("../../../assets/img/arrow-more.png"),
                              alt: "",
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "posiimg",
                            attrs: {
                              src: require("../../../assets/img/arrow-more2.png"),
                              alt: "",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.jiaocaitotal > 4
                    ? _c(
                        "div",
                        {
                          staticClass: "rightarrowbox",
                          on: {
                            click: function ($event) {
                              return _vm.getjiaocaileft(1)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "noneimg",
                            attrs: {
                              src: require("../../../assets/img/arrow-more.png"),
                              alt: "",
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "posiimg",
                            attrs: {
                              src: require("../../../assets/img/arrow-more2.png"),
                              alt: "",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ]
              : _c("div", { staticClass: "noData teaching_no_data" }, [
                  _c("img", { attrs: { src: _vm.$store.getters.noData } }),
                ]),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "lookmore",
            on: {
              click: function ($event) {
                return _vm.getmore("books")
              },
            },
          },
          [_vm._v("查看更多")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "specialtybox" }, [
        _vm._m(4),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "contbox" },
          _vm._l(_vm.navList, function (item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "case",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.toSecond(item.url)
                  },
                },
              },
              [
                _c("img", { attrs: { src: item.icon } }),
                _vm._v(" "),
                _c("div", { staticClass: "fontbox" }, [
                  _c("h2", [_vm._v(_vm._s(item.specialClassName))]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(item.description))]),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "zhuanti" }, [
        _vm._m(5),
        _vm._v(" "),
        _c("div", { staticClass: "contbox" }, [
          _c(
            "div",
            { staticClass: "case zhuantione", on: { click: _vm.deyu } },
            [
              _c("h2", [_vm._v("德育")]),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src: require("../../../assets/img/image/zhuanti1.png"),
                  alt: "",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "case zhuanti_er", on: { click: _vm.tiYu } },
            [
              _c("h2", [_vm._v("体育")]),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src: require("../../../assets/img/image/zhuanti2.png"),
                  alt: "",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "case zhuanti_san", on: { click: _vm.meiyu } },
            [
              _c("h2", [_vm._v("美育")]),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src: require("../../../assets/img/image/zhuanti3.png"),
                  alt: "",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "case zhuanti_si", on: { click: _vm.laoDong } },
            [
              _c("h2", [_vm._v("劳动教育")]),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src: require("../../../assets/img/image/zhuanti4.png"),
                  alt: "",
                },
              }),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head" }, [
      _c("span"),
      _vm._v(" "),
      _c("h1", [_vm._v("专业与课程服务中心")]),
      _vm._v(" "),
      _c("span"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head" }, [
      _c("span"),
      _vm._v(" "),
      _c("h1", [_vm._v("虚拟仿真实训中心")]),
      _vm._v(" "),
      _c("span"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head" }, [
      _c("span"),
      _vm._v(" "),
      _c("h1", [_vm._v("教师能力提升中心")]),
      _vm._v(" "),
      _c("span"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head" }, [
      _c("span"),
      _vm._v(" "),
      _c("h1", [_vm._v("教材资源中心")]),
      _vm._v(" "),
      _c("span"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head" }, [
      _c("span"),
      _vm._v(" "),
      _c("h1", [_vm._v("首都特色教育")]),
      _vm._v(" "),
      _c("span"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head" }, [
      _c("span"),
      _vm._v(" "),
      _c("h1", [_vm._v("专题活动")]),
      _vm._v(" "),
      _c("span"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }